function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Pfad_189",
  "data-name": "Pfad 189",
  d: "M0,117.031v16.427H10.454v-2.987H2.986v-13.44Z",
  transform: "translate(0 -97.446)",
  fill: "#d69e00"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Pfad_190",
  "data-name": "Pfad 190",
  d: "M427.506.194V3.179h7.467v13.44h2.986V.194Z",
  transform: "translate(-355.844 -0.194)",
  fill: "#d69e00"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_70",
  "data-name": "Gruppe 70",
  transform: "translate(54.446 6.964)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_191",
  "data-name": "Pfad 191",
  d: "M343.235,44.826a7.168,7.168,0,0,0-1.543-1.454,8.469,8.469,0,0,0-1.8-.95A10.038,10.038,0,0,0,338,41.9a11.181,11.181,0,0,0-1.855-.163,12.942,12.942,0,0,0-4.541.772,10.408,10.408,0,0,0-3.592,2.211,10.026,10.026,0,0,0-2.36,3.488,12.774,12.774,0,0,0,0,9.142,10.022,10.022,0,0,0,2.36,3.487A10.388,10.388,0,0,0,331.6,63.05a12.942,12.942,0,0,0,4.541.772,10.473,10.473,0,0,0,4.215-.89,8.034,8.034,0,0,0,3.384-2.76l-3.859-2.879a5.022,5.022,0,0,1-1.81,1.662,5.215,5.215,0,0,1-2.523.593,5.444,5.444,0,0,1-2.33-.5,5.7,5.7,0,0,1-1.885-1.41,6.748,6.748,0,0,1-1.261-2.137,8.2,8.2,0,0,1,0-5.417,6.563,6.563,0,0,1,1.276-2.152,5.757,5.757,0,0,1,4.348-1.914,5.578,5.578,0,0,1,2.3.445,4.549,4.549,0,0,1,1.677,1.276Z",
  transform: "translate(-324.803 -41.739)",
  fill: "#081f2f"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Pfad_192",
  "data-name": "Pfad 192",
  d: "M141.142,65.941h5.105L148,61.489h8.162l1.811,4.452H163.2l-9.142-21.014h-3.829Zm13.446-8.37h-5.135l2.553-6.53Zm10.359,8.37h4.63V44.927h-4.63Z",
  transform: "translate(-117.483 -37.428)",
  fill: "#d69e00"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Pfad_193",
  "data-name": "Pfad 193",
  d: "M52.122,65.941H65.33V61.667H56.752V44.926h-4.63Z",
  transform: "translate(-43.384 -37.428)",
  fill: "#081f2f"
});

var SvgLogoLaic = function SvgLogoLaic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_LAIC",
    "data-name": "Logo LAIC",
    width: 82.115,
    height: 36.012,
    viewBox: "0 0 82.115 36.012",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoLaic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_laic.eba64258.svg";
export { ForwardRef as ReactComponent };